import { FormProps } from "./Form.types";
import { useClassNames } from "../../../structure";

export default function Form({ children, classNames, onSubmit }: FormProps) {
  const style = useClassNames(classNames);
  return (
    <form onSubmit={onSubmit} style={{ ...style, boxSizing: "border-box" }}>
      {children}
    </form>
  );
}
